<template>
	<section class="banner">
		<picture v-if="data.image" class="banner__image">
			<source v-if="data.image.sourceUrlDesk" media="(min-width: 1200px)" :srcset="data.image.sourceUrlDesk">
			<source v-if="data.image.sourceUrlTab" media="(min-width: 640px)" :srcset="data.image.sourceUrlTab">
			<source v-if="data.image.sourceUrlMob" media="(min-width: 320px)" :srcset="data.image.sourceUrlMob">
			<img class="cover-img" :src="data.image.sourceUrlDesk" alt="">
		</picture>

		<b-container>
			<div class="banner__caption">
				<SvgIcon class="banner__caption-icon" iconName="ico-happy"/>

				<h1 v-if="data.title" class="banner__caption-title" v-html="data.title"></h1>
				<h2 v-if="data.title" class="section-title" v-html="data.bigTitle"></h2>
				<h2 v-if="data.title" class="section-title section-title--sm" v-html="data.smTitle"></h2>
				<p v-if="data.text" class="banner__caption-text" v-html="data.text"></p>
				<p>{{ envBackendUrl }}</p>

				<span
					v-if="data.scrollTo.id"
					class="banner__btn btn"
					@click="e => clickItem(e, `#${data.scrollTo.id}`)"
				>{{ data.scrollTo.button }}
				</span>
				<span
					v-if="data.scrollTo.id"
					class="btn btn--white btn--lg"
					@click="e => clickItem(e, `#${data.scrollTo.id}`)"
				>{{ data.scrollTo.button }}
				</span>
				<span
					v-if="data.scrollTo.id"
					class="btn btn--grey btn--sm"
					@click="e => clickItem(e, `#${data.scrollTo.id}`)"
				>{{ data.scrollTo.button }}
				</span>
				<span
					v-if="data.scrollTo.id"
					class="btn btn--md"
					@click="e => clickItem(e, `#${data.scrollTo.id}`)"
				>{{ data.scrollTo.button }}
				</span>
			</div>
		</b-container>
	</section>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';

export default {
	components: {
		SvgIcon
	},
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			scrollOptions: {
				easing: 'ease-in-out',
				offset: -70,
				force: true
			}
		};
	},
	computed: {
		envBackendUrl() {
			return process.env.VUE_APP_BACKEND_URL;
		}
	},
	methods: {
		clickItem (e, scrollTo) {
			e.preventDefault();
			VueScrollTo.scrollTo(scrollTo, 600, this.scrollOptions);
		}
	}
};
</script>

<style lang="scss" scoped>
.banner {
	height: 100vh;
	position: relative;
	max-height: 600px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba($black, .75);
		z-index: 1;
	}

	@include mq($sm) {
		max-height: 400px;
	}
}

.banner__caption {
	@include center;
	text-align: center;
	color: $white;
	z-index: 1;
}

.banner__image {
	position: absolute;
	width: 100%;
	height: 100%;
	left: 0;
	top: 0;
	overflow: hidden;
}

.banner__caption-icon {
	color: $white;
	font-size: 20px;
}

.banner__btn {
	margin: 30px 10px 0;
}
</style>
